export const iconFontAwesomeReligionHanukiah = (
	<i className="fa-solid fa-hanukiah"></i>
);
